export const ADMIN_OPTIONS = [
    {label: 'Listing Approvals', value: 'Listing Approvals'},    
    {label: 'Flagged Listing', value: 'Flagged Listing'}
];
export const USER_OPTIONS = [
    {label: 'Account Details', value: 'accountDetails'},
    {label: 'Activity', value: 'activity'},
    {label: 'Messages', value: 'messages'},
    {label: 'My Listings', value: 'My Listings'},
    {label: 'Log out', value: 'logOut'},
];
export const DESTINATION_OPTIONS = [
    {label: 'Durango, MX', value: 'durango:durango:mx'},
    {label: 'CDMX (Ciudad de Mexico), MX', value: 'cdmx:mexico:mx'},
    {label: 'Chicago, IL', value: 'chicago:il:usa'}
];
export const GLOBAL_ACTION_OPTIONS_NON_USER = [
    {label: 'Help Center', value: 'helpCenter'},
    {label: 'Become a host', value: 'becomeHost'},
    {label: 'Log in', value: 'loginSignup'},
    {label: 'Sign up', value: 'signup'},
    {label: 'Nearby Events', value: 'nearbyEvents'},
    {label: 'All Events', value: 'allEvents'},
];
export const GLOBAL_ACTION_OPTIONS_USER = [
    {label: 'Help Center', value: 'helpCenter'},
    {label: 'Become a host', value: 'becomeHost'},
    {label: 'Nearby Events', value: 'nearbyEvents'},
    {label: 'All Events', value: 'allEvents'},
    {label: 'Log out', value: 'logOut'},
];
export const EVENT_OPTIONS = [
    {label: 'Nearby Events', value: 'nearbyEvents'},
    {label: 'All Events', value: 'allEvents'}
];


export const MAIN_AMENITIES = [
    'Alcohol',
    'Food',
    'Music',
    'Bluetooth Speakers',
    'Wi-Fi',
    'Towels',
    'Shower',
    'Photos',
    'Pet Friendly',
    'Smoking',
    'Heated Pool',
];

export const HOUSE_RULES = [
    {label: 'Infants', allowed: false, icon: 'children'},
    {label: 'Alcohol', allowed: false, icon: 'alcohol'},
    {label: 'Pets', allowed: false, icon: 'pets'},
    {label: 'Music', allowed: false, icon: 'music'},
    {label: 'Food', allowed: false, icon: 'food'},
    {label: 'Smoking', allowed: false, icon: 'smoking'},
    {label: 'Photos', allowed: false, icon: 'photos'},
];
export const AMENITIES_2 = [
    { 
        category: 'Pool Features',
        items: [
            {label: 'Heated Pool', value: 'Heated Pool', isMaterialIcon: true, icon: 'heat'},
            {label: 'Diving Board', value: 'Diving Board'},
            {label: 'Waterfall', value: 'Waterfall'},
            {label: 'Slide', value: 'Slide'},
            {label: 'Infinity Edge', value: 'Infinity Edge'},
        ]
    },
    {
        category: 'Entertainment',
        items: [
            {label: 'Bluetooth Speakers', value: 'Bluetooth Speakers', isMaterialIcon: true, icon: 'bluetooth_speakers'},
            {label: 'TV', value: 'TV', isMaterialIcon: true, icon: 'television'},
            {label: 'Pool Basketball', value: 'Pool Basketball', isMaterialIcon: true, icon: 'basketball'},
            {label: 'Pool Volleyball', value: 'Pool Volleyball', isMaterialIcon: true, icon: 'volleyball'},
            {label: 'Cornhole', value: 'Cornhole'},
        ]
    },
    {
        category: 'Furniture',
        items: [
            {label: 'Lounge Chairs', value: 'Lounge Chairs'},
            {label: 'Umbrellas', value: 'Umbrellas', isMaterialIcon: true, icon: 'beach_umbrella'},
            {label: 'Dining Table', value: 'Dining Table', isMaterialIcon: true, icon: 'dining_table'},
            {label: 'Cabana', value: 'Cabana', isMaterialIcon: true, icon: 'cabana'},
            {label: 'Hammocks', value: 'Hammocks'},
        ]
    },

    {
        category: 'Cooking',
        items: [
            {label: 'BBQ Grill', value: 'BBQ Grill', isMaterialIcon: true, icon: 'grill'},
            {label: 'Outdoor Kitchen', value: 'Outdoor Kitchen', isMaterialIcon: true, icon: 'kitchen'},
            {label: 'Mini Fridge', value: 'Mini Fridge', isMaterialIcon: true, icon: 'refigerator'},
        ]
    },
    {
        category: 'Kids',
        items: [
            {label: 'Kiddie Pool', value: 'Kiddie Pool'},
            {label: 'Life Jackets', value: 'Life Jackets'},
            {label: 'Pool Toys', value: 'Pool Toys'},
            {label: 'Splash Pad', value: 'Splash Pad'},
            {label: 'Baby Changing Station', value: 'Baby Changing Station', isMaterialIcon: true, icon: 'baby_changing_station'},
        ]
    },
    {
        category: 'Accessibility',
        items: [    
            {label: 'Pool Lift', value: 'Pool Lift', isMaterialIcon: true, icon: 'wheelchair'},
            {label: 'Ramp', value: 'Ramp', isMaterialIcon: true, icon: 'accessibility'},
            {label: 'Wide Gate', value: 'Wide Gate'},
        ]
    },
    {
        category: 'Extras',
        items: [
            {label: 'Towels Included', value: 'Towels Included', icon: 'towel', isLucideIcon: true},
            {label: 'Wi-Fi', value: 'Wi-Fi', isMaterialIcon: true, icon: 'wifi'},
            {label: 'Changing Room', value: 'Changing Room'},
            {label: 'Sauna', value: 'Sauna', isMaterialIcon: true, icon: 'sauna'},
            {label: 'Outdoor Shower', value: 'Outdoor Shower', isMaterialIcon: true, icon: 'shower'},
        ]
    }
];

export const AMENITIES = [
    {label: 'Heated Pool', value: 'Heated Pool'},
    {label: 'Hot Tub / Spa', value: 'Hot Tub / Spa'},
    {label: 'Saltwater Pool', value: 'Saltwater Pool'},
    {label: 'Water Slide', value: 'Water Slide'},
    {label: 'Diving Board', value: 'Diving Board'},
    {label: 'Waterfall', value: 'Waterfall'},
    {label: 'Pool Basketball', value: 'Pool Basketball'},
    {label: 'Pool Volleyball', value: 'Pool Volleyball'},
    {label: 'Pool Toys', value: 'Pool Toys'},
    {label: 'Cold Plunge', value: 'Cold Plunge'},
    {label: 'Restroom', value: 'Restroom'},
    {label: 'Outdoor Shower', value: 'Outdoor Shower'},
    {label: 'Changing Area', value: 'Changing Area'},
    {label: 'Private Entrance', value: 'Private Entrance'},
    {label: 'Lounge Chairs', value: 'Lounge Chairs'},
    {label: 'Umbrellas / Shade', value: 'Umbrellas / Shade'},
    {label: 'Cabana', value: 'Cabana'},
    {label: 'Covered Patio', value: 'Covered Patio'},
    {label: 'Hammocks', value: 'Hammocks'},
    {label: 'Fire Pit', value: 'Fire Pit'},
    {label: 'Grill', value: 'Grill'},
    {label: 'Outdoor Kitchen', value: 'Outdoor Kitchen'},
    {label: 'Dining Table', value: 'Dining Table'},
    {label: 'Mini Fridge', value: 'Mini Fridge'},
    {label: 'Ice Maker', value: 'Ice Maker'},
    {label: 'Bluetooth Speakers', value: 'Bluetooth Speakers'},
    {label: 'Outdoor TV', value: 'Outdoor TV'},
    {label: 'Projector / Movie Screen', value: 'Projector / Movie Screen'},
    {label: 'Wi-Fi', value: 'Wi-Fi'},
    {label: 'Yard Games', value: 'Yard Games'},
    {label: 'Towels Provided', value: 'Towels Provided'},
    {label: 'Life Jackets', value: 'Life Jackets'},
    {label: 'Child Safety Gate', value: 'Child Safety Gate'},
    {label: 'Guest Parking', value: 'Guest Parking'},
    {label: 'EV Charging', value: 'EV Charging'},
    {label: 'Playground', value: 'Playground'},
    {label: 'Pickleball Court', value: 'Pickleball Court'},
    {label: 'Basketball Court', value: 'Basketball Court'},
    {label: 'Tennis Court', value: 'Tennis Court'},
    {label: 'Sauna', value: 'Sauna'},
    {label: 'Gym Access', value: 'Gym Access'},
];